import define from '@ingka/webc-tools';
import { Sheet } from './src/Sheet.js';
import { Prompt } from './src/Prompt.js';
import { ModalHeader } from './src/ModalHeader.js';
import { ModalFooter } from './src/ModalFooter.js';
export { Sheet, Prompt, ModalHeader, ModalFooter };
export const modalTagName = define('sheet', Sheet);
export const modalHeaderTagName = define('modal-header', ModalHeader);
export const modalFooterTagName = define('modal-footer', ModalFooter);
export const promptTagName = define('prompt', Prompt);
